import { createUseStyles } from 'react-jss';
import { BaseTheme } from '../Config/Theme';

export const Apparel = () => {
    const style = useStyles();

    return (
        <div className={style.container}>
            <div className={style.title}>Apparel</div>
        </div>
    );
};

const useStyles = createUseStyles((theme: BaseTheme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        color: theme.text.primaryColor,
    },
}));
